.filter {
  min-width: 180px;
}

.technicianFilter {
  min-width: 240px;
}

/* scrolls both ways, so the day headers and technician names can stay pinned */
.scroller {
  max-height: 75vh;
  overflow: auto;
  border: var(--ant-line-width) solid var(--ant-color-border-secondary);
  border-radius: var(--ant-border-radius);
}

.board {
  --technician-column: 220px;
  --lane-height: calc(var(--ant-control-height-sm) + var(--ant-padding-xxs) * 2);
  /* opaque surface behind pinned cells; rows lay a translucent tint over it */
  --surface: var(--ant-color-bg-container);
  display: flex;
  flex-direction: column;
  min-width: min-content;
}

.weekView {
  --day-min-width: 110px;
}

.monthView,
.monthsView {
  --technician-column: 180px;
  --day-min-width: 26px;
}

.headerRow,
.technicianRow {
  display: grid;
}

.headerRow {
  position: sticky;
  top: 0;
  z-index: 4;
  border-bottom: var(--ant-line-width-bold) solid var(--ant-color-border);
  background: linear-gradient(var(--ant-color-fill-alter), var(--ant-color-fill-alter)),
    var(--surface);
}

.headerCorner {
  position: sticky;
  left: 0;
  z-index: 5;
  display: flex;
  align-items: center;
  padding: var(--ant-padding-xs) var(--ant-padding-sm);
  font-weight: var(--ant-font-weight-strong);
  border-right: var(--ant-line-width) solid var(--ant-color-border-secondary);
  background: inherit;
}

.monthBand {
  padding: var(--ant-padding-xxs) 0;
  font-weight: var(--ant-font-weight-strong);
  border-bottom: var(--ant-line-width) solid var(--ant-color-split);
  border-left: var(--ant-line-width-bold) solid var(--ant-color-border);
}

/* keeps the month name readable while its days scroll past the names column */
.monthBandLabel {
  position: sticky;
  left: calc(var(--technician-column) + var(--ant-padding-xs));
  padding: 0 var(--ant-padding-xs);
  white-space: nowrap;
}

.technicianRow {
  --row-tint: transparent;
  border-bottom: var(--ant-line-width-bold) solid var(--ant-color-border);
  background: linear-gradient(var(--row-tint), var(--row-tint)), var(--surface);
}

.technicianRow:last-child {
  border-bottom: none;
}

.technicianRowAlternate {
  --row-tint: var(--ant-color-fill-tertiary);
}

/* follows one technician across the days */
.technicianRow:hover {
  --row-tint: var(--ant-color-fill-secondary);
}

.dayHeader {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: var(--ant-padding-xxs) 0;
  font-size: var(--ant-font-size-sm);
  border-right: var(--ant-line-width) solid var(--ant-color-split);
}

.weekday {
  color: var(--ant-color-text-secondary);
}

.nameCell {
  position: sticky;
  left: 0;
  background: inherit;
  grid-column: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: var(--ant-padding-xxs);
  min-width: 0;
  padding: var(--ant-padding-xs) var(--ant-padding-sm);
  border-right: var(--ant-line-width) solid var(--ant-color-border-secondary);
  z-index: 3;
}

.manualAssignments {
  font-size: var(--ant-font-size-sm);
}

.manualLabel {
  font-size: var(--ant-font-size-sm);
}

.manualTag {
  cursor: pointer;
  margin-inline-end: 0;
  /* stays distinct on tinted (alternate and hovered) rows */
  background: var(--surface);
}

.dayCell {
  border: none;
  border-right: var(--ant-line-width) solid var(--ant-color-split);
  background: transparent;
  padding: 0;
  cursor: pointer;
}

.dayCell:hover:not(:disabled) {
  background: var(--ant-color-primary-bg-hover);
}

.dayCell:disabled {
  cursor: default;
}

.weekend {
  background: var(--ant-color-fill-quaternary);
}

.today {
  background: var(--ant-color-primary-bg);
}

.monthStart {
  border-left: var(--ant-line-width-bold) solid var(--ant-color-border);
}

.bar {
  z-index: 2;
  align-self: center;
  margin: var(--ant-padding-xxs) calc(var(--ant-padding-xxs) / 2);
  min-width: 0;
  height: var(--ant-control-height-sm);
  padding: 0 var(--ant-padding-xs);
  border: var(--ant-line-width) solid transparent;
  border-radius: var(--ant-border-radius-sm);
  font-size: var(--ant-font-size-sm);
  text-align: left;
  cursor: pointer;
}

.monthView .bar,
.monthsView .bar {
  padding: 0 calc(var(--ant-padding-xxs) / 2);
  text-align: center;
}

.barLabel {
  display: block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.barScheduled {
  background: var(--ant-color-primary-bg);
  border-color: var(--ant-color-primary-border);
  color: var(--ant-color-primary-text);
}

.barActive {
  background: var(--ant-color-success-bg);
  border-color: var(--ant-color-success-border);
  color: var(--ant-color-success-text);
}

.barEnding {
  background: var(--ant-color-warning-bg);
  border-color: var(--ant-color-warning-border);
  color: var(--ant-color-warning-text);
}

.barCompleted {
  background: var(--ant-color-fill-secondary);
  border-color: var(--ant-color-border);
  color: var(--ant-color-text-secondary);
}

.legendSwatch {
  display: inline-block;
  width: var(--ant-font-size);
  height: var(--ant-font-size);
  border: var(--ant-line-width) solid transparent;
  border-radius: var(--ant-border-radius-xs);
}
